<template>
    <div class="bank_card">
        <Header tit="绑定银行卡" color="1"></Header>
        <div class="user_data">
            <div class="input_bar box_shadow">
                <div class="head">请填写以下信息</div>
                <div class="item">
                    <div class="label">持卡人姓名</div>
                    <input type="text" v-model="data.real_name" disabled placeholder="请输入真实姓名" />
                </div>
                <div class="item">
                    <div class="label">身份证号</div>
                    <input type="text" v-model="data.id_card_num" disabled placeholder="请输入证件号" />
                </div>
            </div>
            <div class="input_bar box_shadow">
                <div class="item select_bank">
                    <div class="label">银行</div>
                    <div class="op" @click="bank_name">
                        <div class="status">{{data.open_bank ? data.open_bank : '请选择'}}</div>
                        <img src="@/assets/my/ic_next_gray.png" alt />
                    </div>
                </div>
                <div class="item">
                    <div class="label">银行卡号</div>
                    <input type="text" v-model="data.banK_num" :disabled="dis" placeholder="请输入银行卡号" />
                </div>
            </div>
        </div>
        <div class="tip">
            <div class="tit gray_color">提示</div>
            <div class="content">
<!--                 <p>银行卡必须为本人或亲属名下银行卡。</p>
 -->                <p>确认后不可修改。</p>
            </div>
        </div>
        <BigBtn label="确认" class="submit_data" :disabled="!data.open_bank || !data.banK_num"></BigBtn>
    </div>
</template>
<script>
import Header from "../public/header";
import BigBtn from "../public/button";
import { bank_list } from "@/common/data";
export default {
    components: { Header, BigBtn },
    data() {
        return {
            data: {},
            select_bank_name: "",
            picker: null,
            dis:false
        };
    },
    mounted() {
        this.get_data();
    },
    beforeDestroy() {
        if (this.picker) {
            this.picker.hide();
            this.picker.dispose();
        }
    },
    methods: {
        get_data() {
            this.$get(this.$path.member_info_detail).then(res => {
                if (res.success) {
                    this.data = res.data;
                    this.dis = this.data.banK_num ? true : false;
                }
            });
        },
        bank_name() {
            if(this.dis)return;
            this.picker = new mui.PopPicker({
                layer: 1
            });
            let index = 0;
            for (const i in bank_list) {
                if (bank_list[i].value == this.data.open_bank) {
                    index = i;
                }
            }
            this.picker.pickers[0].setSelectedIndex(index);
            this.picker.setData(bank_list);
            this.picker.show(SelectedItem => {
                this.data.open_bank = SelectedItem[0].value;
            });
        },
        click_BigBtn() {
            this.$post(this.$path.bankInfo, this.data).then(res => {
                if (res.success) {
                    this.$alert("保存成功！");
                    this.$router.go(-1);
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import "./user_data.scss";
.bank_card {
    background-image: linear-gradient(
        to bottom,
        #f9bf3a,
        #f9bf3a,
        #ffffff,
        #ffffff
    );
    .user_data {
        width: 100%;
        .input_bar:nth-child(2) {
            margin-top: 0.3rem;
        }
        .select_bank {
            display: flex;
            justify-content: space-between;
            .op {
                width: 1.9rem;
                height: 100%;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                color: #c5cad5;
                margin-right: 0.3rem;
                font-size: 0.3rem;
                img {
                    width: 0.3rem;
                    height: 0.3rem;
                }
            }
        }
    }
    .tip {
        margin-top: 0.3rem;
        .content {
            color: #e84a10;
            margin-top: 0.1rem;
        }
    }
    .submit_data {
        margin: 0.6rem 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/my/bank_card.vue